import { StorageKey } from 'constants/storage';

function run() {
  window.LA_FIRST_TIME_USER = false;
  try {
    const history = localStorage.getItem(StorageKey.PROGRESS) || null;
    window.LA_FIRST_TIME_USER = history === null;
  } catch (e) {
    window.LA_FIRST_TIME_USER = false;
  }
}

run();
